class ExitIntentOverlay {
  constructor(element, ...options) {
    this.defaults = {
      closeSelector: '.js-close-content-overlay',
      activeClass: '-is-active',
      eventCategory: 'Exit-Intent-Teaser',
    };

    this.element = element;
    this.options = Object.assign({}, this.defaults, ...options);

    this.init();
  }

  init() {
    this.active = false;
    this.closeElements = [].slice.call(this.element.querySelectorAll(this.options.closeSelector));
    this.listener = new AbortController();

    this.bindEvents();
  }

  toggleOverlay() {
    this.active = !this.active;
    this.element.classList.toggle(this.options.activeClass);
    document.documentElement.classList.toggle('no-scroll');
  }

  open() {
    this.active = true;
    this.element.classList.add(this.options.activeClass);
    document.documentElement.classList.add('no-scroll');

    gtagSendEvent('mc_data_event', {
      category: this.options.eventCategory,
      action: 'Open',
      label: this.element.dataset.eventLabel,
    });
  }

  close() {
    this.active = false;
    this.element.classList.remove(this.options.activeClass);
    document.documentElement.classList.remove('no-scroll');

    gtagSendEvent('mc_data_event', {
      category: this.options.eventCategory,
      action: 'Close',
      label: this.element.dataset.eventLabel,
    });
  }

  keyHandler(e) {
    const shouldExit = e.keyCode === 27; // user hits escape

    if (shouldExit) {
      this.close();
    }
  }

  mouseHandler(e) {
    const shouldShowExitIntent = !e.toElement
      && !e.relatedTarget
      && e.clientY < 10;

    if (shouldShowExitIntent) {
      this.listener.abort();
      this.open();
    }
  }

  bindEvents() {
    this.closeElements.forEach(function (el) {
      if(!el.dataset.hasListener) {
        el.addEventListener('click', this.close.bind(this));
      }
      el.dataset.hasListener = true;
    }.bind(this));

    document.addEventListener('mouseout', this.mouseHandler.bind(this), this.listener);
    document.addEventListener('keydown', this.keyHandler.bind(this));
  }
}
